module.exports = "../img/LN-Mas.svg";


//////////////////
// WEBPACK FOOTER
// ./Statics/img/LN-Mas.svg
// module id = 32
// module chunks = 0